module.exports = __webpack_public_path__ + "img/logo_blanco.52cf7e14.png";